<ng-container *ngIf="hasCustomView;else standard">
  <div class="form-title">
    <span class="subtitle">{{title}}</span>
    
    <container-element  [ngSwitch]="viewMode">
      <span *ngSwitchCase="'popover'">
        <div class="rollup-down">
          <nb-icon class="arrowhead" icon="close-outline" #closeIcon (click)="togglePopover()"></nb-icon>
        </div>
      </span>
      <span *ngSwitchCase="'collapsible'">
        <ng-container *ngIf="findOpen;else collapsed">
          <div class="rollup-down">
            <nb-icon class="arrowhead" icon="arrowhead-up-outline" #chevron (click)="toggleIcon()"></nb-icon>
          </div>
        </ng-container>
        <ng-template #collapsed>
          <div class="rollup-down">
            <nb-icon class="arrowhead" icon="arrowhead-down-outline" #chevron (click)="toggleIcon()"></nb-icon>
          </div>
        </ng-template>
      </span>
      <span *ngSwitchDefault>
        
      </span>
    </container-element>
    <!-- <nb-menu tag="contextMenu" [items]="contextMenuItems" ubsHorizontalMenu></nb-menu> -->
    <!-- <nb-actions>
        <nb-action *ngIf="hasContextMenu" icon="chevron-down-outline"[nbContextMenu]="contextMenuItems" nbContextMenuTag="contextMenu" nbContextMenuPlacement="bottom">Related

        </nb-action>
    </nb-actions> -->
  </div>
    <ubs-custom-container [addForm]="addForm" [customView]="customView" [action]="action"></ubs-custom-container>
</ng-container>
<ng-template #standard>
    <div class="form-title">
        <span class="subtitle">{{title}}</span>
        <container-element  [ngSwitch]="viewMode">
          <span *ngSwitchCase="'popover'">
            <div class="rollup-down">
              <nb-icon class="arrowhead" icon="close-outline" #closeIcon (click)="togglePopover()"></nb-icon>
            </div>
          </span>
          <span *ngSwitchCase="'collapsible'">
            <ng-container *ngIf="findOpen;else collapsed">
              <div class="rollup-down">
                <nb-icon class="arrowhead" icon="arrowhead-up-outline" #chevron (click)="toggleIcon()"></nb-icon>
              </div>
            </ng-container>
            <ng-template #collapsed>
              <div class="rollup-down">
                <nb-icon class="arrowhead" icon="arrowhead-down-outline" #chevron (click)="toggleIcon()"></nb-icon>
              </div>
            </ng-template>
          </span>
          <span *ngSwitchDefault>
            
          </span>
        </container-element>
      </div>
    <ubs-ofbiz-form [ofbizForm]="addForm" [title]="title" [state] ="state" (resetAction)="resetAction($event)" (openDialogContainerEvent)="openDialogContainer($event)" [target]="target" ></ubs-ofbiz-form>
</ng-template>

